import { atom } from 'jotai';
import { UserSession } from './types';
import {
  cachedEntityAtom,
  setActiveEntityAtomValue,
} from '../communities/atoms';

export const userSessionAtom = atom<UserSession | null>(null);

export const setUserSessionAtom = atom(
  null,
  (get, set, session: UserSession | null) => {
    const cachedEntity = get(cachedEntityAtom);
    const hasManagerUser = session?.user?.manager_id;
    const isCacheOwner = session?.user?.manager_id !== cachedEntity?.userId;

    if (hasManagerUser && isCacheOwner) {
      set(setActiveEntityAtomValue, null);
    }

    set(userSessionAtom, session);
  }
);
